/*
 * Concepts Messages
 *
 * This contains all the text for the Concepts component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.TemplateFlows.upload';

export default defineMessages({
  modal: {
    uploadMessage: {
      id: `${scope}.uploadMessage`,
      defaultMessage:
        "Drag & Drop or <span class='color-blue-6'>browse</span> for files here",
    },
    cancel: {
      id: `${scope}.cancel`,
      defaultMessage: 'Close',
    },
    submit: {
      id: `${scope}.submit`,
      defaultMessage: 'Save',
    },
    labelUpload: {
      id: `${scope}.labelUpload`,
      defaultMessage: 'Upload File',
    },
  },
});
